/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Elemento de empresa, misma entidad para listado y detalle. Mezcla usuario y empresa
 * @export
 * @interface AdminCompany
 */
export interface AdminCompany {
    /**
     * 
     * @type {number}
     * @memberof AdminCompany
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCompany
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompany
     */
    nif?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompany
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompany
     */
    contactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompany
     */
    contactName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompany
     */
    contactSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompany
     */
    contactPhone?: string;
    /**
     * new, accepted
     * @type {string}
     * @memberof AdminCompany
     */
    status?: string;
    /**
     * number of offers fct
     * @type {number}
     * @memberof AdminCompany
     */
    offersFct?: number;
    /**
     * number of offers job
     * @type {number}
     * @memberof AdminCompany
     */
    offersJob?: number;
    /**
     * number of candidates in total fct
     * @type {number}
     * @memberof AdminCompany
     */
    candidatesFct?: number;
    /**
     * number of candidates in total job
     * @type {number}
     * @memberof AdminCompany
     */
    candidatesJob?: number;
    /**
     * profile completed
     * @type {boolean}
     * @memberof AdminCompany
     */
    completed?: boolean;
    /**
     * link to enter emulating the company
     * @type {string}
     * @memberof AdminCompany
     */
    emulationLink?: string;
}

export function AdminCompanyFromJSON(json: any): AdminCompany {
    return AdminCompanyFromJSONTyped(json, false);
}

export function AdminCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nif': !exists(json, 'nif') ? undefined : json['nif'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'contactEmail': !exists(json, 'contact_email') ? undefined : json['contact_email'],
        'contactName': !exists(json, 'contact_name') ? undefined : json['contact_name'],
        'contactSurname': !exists(json, 'contact_surname') ? undefined : json['contact_surname'],
        'contactPhone': !exists(json, 'contact_phone') ? undefined : json['contact_phone'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'offersFct': !exists(json, 'offers_fct') ? undefined : json['offers_fct'],
        'offersJob': !exists(json, 'offers_job') ? undefined : json['offers_job'],
        'candidatesFct': !exists(json, 'candidates_fct') ? undefined : json['candidates_fct'],
        'candidatesJob': !exists(json, 'candidates_job') ? undefined : json['candidates_job'],
        'completed': !exists(json, 'completed') ? undefined : json['completed'],
        'emulationLink': !exists(json, 'emulation_link') ? undefined : json['emulation_link'],
    };
}

export function AdminCompanyToJSON(value?: AdminCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'nif': value.nif,
        'text': value.text,
        'contact_email': value.contactEmail,
        'contact_name': value.contactName,
        'contact_surname': value.contactSurname,
        'contact_phone': value.contactPhone,
        'status': value.status,
        'offers_fct': value.offersFct,
        'offers_job': value.offersJob,
        'candidates_fct': value.candidatesFct,
        'candidates_job': value.candidatesJob,
        'completed': value.completed,
        'emulation_link': value.emulationLink,
    };
}


